import { Component, NgZone } from '@angular/core';
import { OnInit } from '@angular/core';
import { DashboardCustomerKPIService } from '../../../services';
import { EventService } from '../../../services';
import { ChartDataset } from '../../../interfaces/kpis/customer-kpi-totals';

@Component({
  selector: 'dashboard-customer-kpi-time-windows',
  templateUrl: './dashboard-customer-kpi-timewindows.component.html',
  styleUrls: ['./dashboard-customer-kpi-display.component.scss'],
})
export class DashboardCustomerKPITimeWindowsComponent implements OnInit {
  constructor(
    private dashboardKPIService: DashboardCustomerKPIService,
    private eventService: EventService,
  ) {}

  // pass to display component as Input
  metrics: any[];
  gradeColours: string[];

  async ngOnInit() {
    //console.log("Loaded time windows component");
    this.gradeColours = this.dashboardKPIService.getGradeColours6();

    this.eventService.CustomerKPIRefreshEvent.subscribe(() => {
      this.loadData();
    });
  }

  async loadData() {
    //console.log("Loading TIME WINDOW data, KPI Data: ", this.dashboardKPIService.completedTotals);

    this.metrics = [];
    this.setTimeWindowMetric_Collection();
    this.setTimeWindowMetric_Delivery();
  }

  setTimeWindowMetric_Collection() {
    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'line',
      },
      {
        label: 'Window <2hrs',
        data: this.dashboardKPIService.completedTotals.map(
          (x) => x.timedAppointments_Collection[0],
        ),
        backgroundColor: this.gradeColours[0],
      },
      {
        label: 'Window <4hrs',
        data: this.dashboardKPIService.completedTotals.map(
          (x) => x.timedAppointments_Collection[1],
        ),
        backgroundColor: this.gradeColours[1],
      },
      {
        label: 'Window <8hrs',
        data: this.dashboardKPIService.completedTotals.map(
          (x) => x.timedAppointments_Collection[2],
        ),
        backgroundColor: this.gradeColours[2],
      },
      {
        label: 'Window <24hrs',
        data: this.dashboardKPIService.completedTotals.map(
          (x) => x.timedAppointments_Collection[3],
        ),
        backgroundColor: this.gradeColours[3],
      },
      {
        label: 'Window <48hrs',
        data: this.dashboardKPIService.completedTotals.map(
          (x) => x.timedAppointments_Collection[4],
        ),
        backgroundColor: this.gradeColours[4],
      },
      {
        label: 'Window 48hrs+',
        data: this.dashboardKPIService.completedTotals.map(
          (x) => x.timedAppointments_Collection[5],
        ),
        backgroundColor: this.gradeColours[5],
      },
      // { label: "Timed Appointments %", data: this.dashboardKPIService.completedTotals.map(x => {
      //         return x.completedMoves == 0 ? 0 : (x.timedAppointments.filter((ta, index) => index < 3).reduce((a, b) => a + b) / x.completedMoves) * 100.0
      //     }), backgroundColor: 'rgba(35,47,93, 0.9)', hideInChart: true, isPercentCol: true }
    ];

    // filter out datas with no value
    datas = this.dashboardKPIService.filterZeroData(datas);

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Timed Appointments (Collection)',
      datas,
      labels,
      true,
      this.dashboardKPIService.stackedChartOptions,
    );

    //console.log("Time window metric: ", metric);

    this.metrics.push(metric);
  }

  setTimeWindowMetric_Delivery() {
    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'line',
      },
      {
        label: 'Window <2hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.timedAppointments_Delivery[0]),
        backgroundColor: this.gradeColours[0],
      },
      {
        label: 'Window <4hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.timedAppointments_Delivery[1]),
        backgroundColor: this.gradeColours[1],
      },
      {
        label: 'Window <8hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.timedAppointments_Delivery[2]),
        backgroundColor: this.gradeColours[2],
      },
      {
        label: 'Window <24hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.timedAppointments_Delivery[3]),
        backgroundColor: this.gradeColours[3],
      },
      {
        label: 'Window <48hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.timedAppointments_Delivery[4]),
        backgroundColor: this.gradeColours[4],
      },
      {
        label: 'Window 48hrs+',
        data: this.dashboardKPIService.completedTotals.map((x) => x.timedAppointments_Delivery[5]),
        backgroundColor: this.gradeColours[5],
      },
      // { label: "Timed Appointments %", data: this.dashboardKPIService.completedTotals.map(x => {
      //         return x.completedMoves == 0 ? 0 : (x.timedAppointments.filter((ta, index) => index < 3).reduce((a, b) => a + b) / x.completedMoves) * 100.0
      //     }), backgroundColor: 'rgba(35,47,93, 0.9)', hideInChart: true, isPercentCol: true }
    ];

    // filter out datas with no value
    datas = this.dashboardKPIService.filterZeroData(datas);

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Timed Appointments (Delivery)',
      datas,
      labels,
      true,
      this.dashboardKPIService.stackedChartOptions,
    );

    //console.log("Time window metric: ", metric);

    this.metrics.push(metric);
  }
}
